module.exports = __webpack_public_path__ + "resources/img/main01_gov_m.4e991d38643bb9ac8acc481a3937d6e7.png";